<div style=" text-align: center; margin-top: 10%;">
    <div>
        <fa-icon icon="check-circle" class="fa-5x" style="color: #409E4C;"></fa-icon>
    </div>
    <div class="confirm_msg">
        Password Updated!
    </div>
    <div class="frame">

        Your password has been updated successfully.<br>Please use your new password to log in.
    </div>

    <div style="margin-top: 2em;"><a style="color:#1CA0DA;" [href]="link">Go to Login (Web browser)</a></div>
    <div style="margin-top: 2em;"> Please login with your App if you are using mobile device.</div>
</div>